/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { roofingConfig } from "./roofing-config";

export function RoofingSolutionsPageClient() {
  return <SolutionTemplate config={roofingConfig} />;
}
